import { render, staticRenderFns } from "./rank-group.vue?vue&type=template&id=29fdf6d9&scoped=true&"
import script from "./rank-group.vue?vue&type=script&lang=js&"
export * from "./rank-group.vue?vue&type=script&lang=js&"
import style0 from "./rank-group.vue?vue&type=style&index=0&id=29fdf6d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29fdf6d9",
  null
  
)

export default component.exports